import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  jobs,
  customers,
  moments,
  guests
} from 'app/resources';

import {
  jobs as jobsPath,
  customers as customersPath,
  moments as momentsPath,
  guests as guestsPath
} from 'app/routes';

import {
  setJobParams
} from 'app/actions/jobs';

import {
  setCustomerParams
} from 'app/actions/customers';

import {
  setMomentParams
} from 'app/actions/moments';

import {
  setGuestParams
} from 'app/actions/guests';

import {
  OPERATOR_KEY,
  AND_OPERATOR
} from 'app/hooks/useFilter';

import {
  PAGE_SIZE
} from 'app/utils/Constants';

import {
  jsonToUrlParam
} from 'shared/utils/Utils';

export const SEARCH_PARAM = 'search';

const useDeeplink = () => {
  const resourceParams = useSelector(state => state.params);
  const dispatch = useDispatch();
  const history = useHistory();

  // as of now these params will be the same for each deeplink.
  // can be changed as needed
  const page = 1;
  const perPage = PAGE_SIZE;
  const sortModel = [];

  const load = async (resource, filterModel) => {
    if (!filterModel[OPERATOR_KEY]) {
      filterModel[OPERATOR_KEY] = [{
        operator: AND_OPERATOR,
        value: AND_OPERATOR,
        filterClass: '',
        filterType: ''
      }]
    }

    let path = getPath(resource);
    if (history.location.pathname !== path) {
      history.push(getLink(resource, filterModel));
    }
  }

  const getLink = (resource, filterModel) => {
    if (!filterModel[OPERATOR_KEY]) {
      filterModel[OPERATOR_KEY] = [{
        operator: AND_OPERATOR,
        value: AND_OPERATOR,
        filterClass: '',
        filterType: ''
      }]
    }

    let path = getPath(resource);

    let params = {
      page,
      per_page: perPage,
      filter_model: filterModel,
      sort_model: sortModel
    }

    let searchParam = jsonToUrlParam(params);

    return `${path}?${SEARCH_PARAM}=${searchParam}`
  }

  const openRecord = (resource, record) => {
    let params = resourceParams[resource];
    params.record_id = record.id;

    loadParams(resource, params);
  }

  const closeRecord = resource => {
    let params = resourceParams[resource];
    params.record_id = null;

    loadParams(resource, params);
  }

  const loadParams = (resource, params) => {
    let path = getPath(resource);
    let searchParam = jsonToUrlParam(params);
    let url = `${path}?${SEARCH_PARAM}=${searchParam}`

    history.push(url);
  }

  const getParamsSetter = resource => {
    switch (resource) {
      case jobs:
        return setJobParams;
      case customers:
        return setCustomerParams;
      case moments:
        return setMomentParams;
    }
  }

  const getPath = resource => {
    switch (resource) {
      case jobs:
        return jobsPath;
      case customers:
        return customersPath;
      case moments:
        return momentsPath
    }
  }

  return {
    load,
    getLink,
    openRecord,
    closeRecord
  }
}

export default useDeeplink;
